import hipHop from "../images/SearchPageImages/hip-hop.jpg" ;
import rAndB from "../images/SearchPageImages/r&b.jpg";
import jazz from "../images/SearchPageImages/jazz.jpg";
import rap from "../images/SearchPageImages/rap.jpg";
import soul from "../images/SearchPageImages/soul.jpg";
import christianAndGospel from "../images/SearchPageImages/christian&gospel.jpg";
import countryMusic from "../images/SearchPageImages/country-music.jpg";
import blues from "../images/SearchPageImages/blues.jpg";
import afro from "../images/SearchPageImages/afro.jpg";
import mixed from "../images/SearchPageImages/mixed.jpg";
import dance from "../images/SearchPageImages/dance.jpg";
import sleep from "../images/SearchPageImages/sleep.jpg";
import rock from "../images/SearchPageImages/rock.jpg"

 
 const searchCategories = [
{
    id: 1,
    category: "Hip-Hop",
    color: "#BA5D07",
    searchImage: hipHop
},
{
    id: 2,
    category: "R&B",
    color: "#DC148C",
    searchImage: rAndB
},
{
    id: 3,
    category: "Jazz",
    color: "#E61E32",
    searchImage: jazz
},
{
    id: 4,
    category: "Rap",
    color: "#8D67AB",
    searchImage: rap
},
{
    id: 5,
    category: "Soul",
    color: "#0D73EC",
    searchImage: soul
},
{
    id: 6,
    category: "Christian & Gospel",
    color: "#509BF5",
    searchImage: christianAndGospel
},
{
    id: 7,
    category: "Country Music",
    color: "#283EA3",
    searchImage: countryMusic
},
{
    id: 8,
    category: "Blues",
    color: "#1E3264",
    searchImage: blues
},
{
    id: 9,
    category: "Afro",
    color: "#AF2896",
    searchImage: afro
},
{
    id: 10,
    category: "Mixed",
    color: "#7358FF",
    searchImage: mixed
},
{
    id: 11,
    category: "Dance/Electronic",
    color: "#DC148C",
    searchImage: dance
},
{
    id: 12,
    category: "Sleep",
    color: "#1E3263",
    searchImage: sleep
},
{
    id: 13,
    category: "Rock",
    color: "#E61E32",
    searchImage: rock
},
]

export default searchCategories